<template>
  <div class="sy_big">
    <!-- <div @click="bindtk" style="text-align:center">退款</div> -->
    <div style="position:relative;width:1260px;margin:0 auto">
      <div class="nav">
        <span @click="bindnav(1)" :class="nav_show==1?'nav_active':''">礼包兑换</span>
        <span @click="bindnav(2)" :class="nav_show==2?'nav_active':''">兑换记录</span>
        <div class="search_box">
          <div style="display:flex;align-items:center">
              <img src="../../assets/img/icon-search.png" alt="">
              <input placeholder="礼包名称" @keyup.13=bindsearch() type="search" @input="bindsearch_value" v-model="search_value">
          </div>
          <div style="display:flex;align-items:center">
              <img src="../../assets/img/cancel.png" v-if='search_value' @click="bindsearchs" style="margin-right:8px;" alt="">
              <span @click="bindsearch">搜索</span>
          </div>
          
        </div>
      </div>
    </div>

    <div v-if="nav_show==1">
      <div class="banner">
        <img v-if='user&&user.festival.imageUrlPc' :src="user.festival.imageUrlPc" />
        <img v-else src="../../assets/img/bj.png" />
        
      </div>
	  <div class="city_box">
		<div @click="cityShow=true">{{getCity}}</div>
	  </div>
      <div class="flexss" style="width:1260px;margin:21px auto;display:flex;align-items:center">
          <img style="height:160px;width:285px;margin-right:24px;" v-if='user&&user.festival.imageUrl' :src="user.festival.imageUrl" alt="">
          <img style="height:160px;width:285px;margin-right:24px;" v-else src="../../assets/img/gb.png" alt="">
          <div class="sm_box">
            <div class="sm_top">
              <span style="color:#6D4902;font-size:20px;margin-right: 40px;" v-if="user&&user.festival&&user.festival.showName">{{user.festival.name}}</span>
              <span @click="tpVisible=true" class="dh_jj">兑换须知</span>
            </div>
            <div class="sm_center" style="margin-top:10px;margin-bottom:10px;height: 82px;overflow:auto">
              <!-- <span></span> -->
              <div style="white-space:pre" v-if="user" v-html="user.festival.remark"></div>
            </div>
            <!-- <div class="sm_center">
              <span></span>
              <span>请在以下区域任意选择一款套餐兑换。为保证您的权益，请认真阅读“兑换须知”</span>
            </div> -->
          </div>
      </div>
      <div class="center_nav" v-if="user.festival&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid">
        <div  style="background:white;padding:0">
          <el-select v-model="priceSort" @change="bindzt"  placeholder="价格排序" aria-placeholder="#0A1132" style="border: none;">
            <el-option key="1" label="默认排序" value="1"> </el-option>
            <el-option key="2" label="价格从低到高" value="2"> </el-option>
            <el-option key="3" label="价格从高到低" value="3"> </el-option>
          </el-select>
        </div>
       
        <div style="position: relative;width:600px;height:100%;display: flex;align-items: center;margin-left:20px;">
          <span style="color:#666666;margin-left:58px;margin-right:38px;">价格区间</span>
          <div class="dians"  >
            <input type="number" min="0" @focus="bindfocus" @blur="bindblur" v-model="priceLow" name="" id="" value="" placeholder="最低价" />
            <span>-</span>
            <input type="number" :min="priceLow?priceLow:0" @focus="bindfocus" @blur="bindblur" v-model="priceHigh"  name="" id="" value="" placeholder="最高价"/>
            <span @click="bindqueding" style="cursor:pointer;line-height:24px;padding:0 10px;border:1px solid #F3A251;color:#F3A251;margin-left:20px;height:24px;display: inline-block;margin-right:0">确定</span>
            <span @click="bindqx" v-if='priceLow||priceHigh' style="cursor:pointer;line-height:24px;padding:0 10px;border:1px solid #DDDDDD;color:#888888;margin-left:20px;height:24px;display: inline-block;">取消</span>
          </div>
         
        </div>
      </div>
      <div class="fl_box" v-if="Categories.length>0&&!search_show">
        <div class="one_box">
          <span class="fl_box_ell" @click="bindselete_one(item.id,true)" :class="show_id == item.id?'one_active':''" v-for="(item,index) in Categories" :key='item.id' v-if="item.parentCategoryId==0">{{item.name}}</span>
         
        </div>
        <div class="two_box" v-if='two_list.length>0'>
          <span @click="bindselete_two(item.id)" class="fl_box_ell" :class="show_id_two == item.id?'two_active':''" v-for="(item,index) in two_list" :key='item.id'>{{item.name}}</span>
          <span @click="bindselete_two('')" class="fl_box_ell" :class="show_id_two == ''?'two_active':''" >全部</span>
        </div>
      </div>

      <div
        class="list"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="box flexss" v-for="(item,index) in lb_list" :key="item.id" >
          <div style="position:relative;height:160px;width:160px;margin-bottom:10px">
            <img @click="binddetail(item)" :src="item.imageUrl" />
            <span class="ydh" v-if="item.offSale">已售罄</span>
            <span class="ydh" v-if="item.offSale==false&&item.stockOut==true">{{item.stockOutDesc?item.stockOutDesc:'补货中'}}</span>
          </div>
          <p @click="binddetail(item)" style="width:100%;overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;word-break: break-all;">{{item.name}}</p>
          <!-- <div class="label" v-if="item.tagNames&&item.tagNames.length>0">
            <span v-for="(item1,index1) in item.tagNames" :key="index1" v-if="index1<3">{{item1}}</span>
          </div> -->
          <div v-if='user.festival.id!=$store.state.hidePriceid&&!bindhide(item)'>
              <div class="sale_price" v-if="user.festival.type==2" >
                <img style="width:16px;height:16px;background:white;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img style="width:16px;height:16px;background:white;" v-if="!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
                <span style="font-size:16px;color:#FD5430;font-weight:600">{{item.standardPrice/100}}</span>
                <span style="color:#FD5430;font-weight:600;margin-left:4px;font-size:14px" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
                <span style="font-size:14px;color:#999999;margin-left:6px;text-decoration:line-through;" v-if="item.marketPrice&&item.marketPrice>item.standardPrice">{{item.marketPrice/100}}</span>
                <span style="font-size:14px;color:#999999;margin-left:6px;text-decoration:line-through;" v-if="item.autoRefreshPrice&&!item.marketPrice&&item.itemPriceTotal>item.standardPrice">{{item.itemPriceTotal/100}}</span>
                
              </div>
              <div v-if="user.festival.type==1" style="font-size:14px;color:#999999;height:20px;">
                <!-- <span v-if="item.marketPrice" style="font-size:14px;color:#ff5c4d;font-weight:600;margin-right:4px">市场价</span> -->
                <span v-if="item.marketPrice&&item.marketPrice>item.standardPrice" style="font-size:16px;color:#ff5c4d;font-weight:600;text-decoration:line-through;">{{item.marketPrice/100}}</span>
                <!-- <span v-if="!item.marketPrice&&item.itemPriceTotal>item.standardPrice" style="font-size:16px;color:#ff5c4d;font-weight:600;text-decoration:line-through;">{{item.itemPriceTotal/100}}</span> -->
              </div>
          </div>
          
          <div class="div" @click="binddetail(item)">立即兑换</div>
          <!--<div v-else class="sell div">立即兑换</div>-->
        </div>
        <div v-if="lb_no_show" style="width:246px;margin:165px auto;text-align:center">
          <img style="width:100%" src="../../assets/img/no_lb.png" />
          <p style="color:#0A113;font-size:16px;">暂无礼包</p>
        </div>
      </div>
	  <div class="fy">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        :page-size="10"
        :hide-on-single-page="true"
        :current-page="pageNumber"
        @current-change="bindpage"
        layout="prev, pager, next"
        :total="z_page"
      ></el-pagination>
      
	  </div>
    
      <el-dialog title="兑换须知" :visible.sync="tpVisible" width="640px" center>
        <div
          style="height:350px;max-height:550px;overflow: auto;"
          v-html="AfterSale"
        ></div>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button style="height：42px;width:144px;" @click="tpVisible = false">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <div
      v-if="nav_show==2"
      style="min-height:87vh;background:white;border-top:1px solid #E4E5ED;padding-top:33px;"
      v-loading="loadings"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="order"  v-if="order_list&&order_list.length>0">
        <div class="order_box" v-for="(item,index) in order_list" :key="item.id">
          <div class="order_top">
            <span style="margin-left:23px;margin-right:185px;">订单号：{{item.externalOrderId}}</span>
            <span>下单时间：{{item.createAt}}</span>
          </div>
          <div class="order_bottom">
            <div class="order_b_left">
              <img
                style="height:64px;width:64px;margin-right:16px"
                v-if="item.festivalPackage"
                :src="item.festivalPackage.imageUrl"
              />
              <div>
                <p v-if="item.festivalPackage" style="max-width:500px;font-size:16px;color:#0A1132;overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;word-break: break-all;">{{item.festivalPackage.name}}</p>
                <span style="color:#909199">商品数量：{{item.all_num}}件</span>
              </div>
            </div>
            <div class="sale_price" v-if="user.festival.type==2&&user.festival.id!=$store.state.hidePriceid">
              <img style="width:16px;height:16px;background:white" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
              <img style="width:16px;height:16px;background:white" v-if="!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
              <span style="font-size:16px;color:#FD5430;font-weight:600">{{item.totalPrice/100}}</span>
              <span style="color:#FD5430;font-weight:600;margin-left:4px;font-size:14px" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
            </div>
            <div style="width:150px;text-align:center">
              <span style="color:#F3A251;font-size:16px">{{status_list[item.orderStatus]}}</span>
              <!-- <span style="color:#F3A251;font-size:16px">兑换成功</span>
              <span style="color:#909199;font-size:16px">兑换失败</span>-->
            </div>
            <div style="text-align:center">
              <p class="ljfk_h" @click="bindpay(item)" v-if="item.orderStatus==0">立即付款</p>
              <span
                style="color:#0A1132;font-size:16px;cursor:pointer;"
                @click="bindorderdetail(item.uid,item.festivalPackage.name)"
              >订单详情</span>
              <span
                style="color:#0A1132;font-size:16px;cursor:pointer;margin-left:20px;"
                @click="binddeleta(item,index)"
              >删除订单</span>
            </div>
          </div>
        </div>
        
      </div>
      <div v-if="no_show" style="width:246px;margin:165px auto;text-align:center">
          <img style="width:100%" src="../../assets/img/no_jl.png" />
          <p style="color:#0A113;font-size:16px;">暂无兑换礼包</p>
        </div>
      <div class="fy">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="6"
          :hide-on-single-page="true"
          :current-page="pageNumber1"
          @current-change="bindpage1"
          layout="prev, pager, next"
          :total="z_page1"
        ></el-pagination>
      </div>
    </div>
  <div class="tc_box" v-if='img_show&&NoticeText'>
    <p></p>
    <div class="img_box">
      <div style="position:relative">
        <!-- <img class="img1" src="../../assets/img/tc.png" alt=""> -->
        <div class="tc_center">
            <div class='t_icon'><img src="../../assets/img/tc_icom.png" alt=""></div>
            <div class="tc_title">物流公告</div>
            <div class="tc_text" v-html='NoticeText'>
              <!-- {{NoticeText}} -->
            </div>
        </div>
        <img @click="bindqximg" class="img2" src="../../assets/img/tcx.png" alt="">
      </div>
    </div>
  </div>
  <!-- 选择城市 -->
  <cityList :cityDataList="cityDataList"  @beforeClose="cityShow=false" :cityShow="cityShow" @adressCity="adressChangeCity"/>
  <!-- 选择收货地址 -->
  <el-dialog
      title="选择收货地址"
      :visible.sync="addressVisible"
      width="620px"
      center
    >
      <address_box
        :type="false"
        ref="adbox"
        @bindselects="bindselects"
        @bindqqxs="colseAdressClick"
      ></address_box>
    </el-dialog>
  </div>
</template>

<script>
import nav from '../nav'
import getCurrentCityName from '../../js/map'
import links from '../../js/link_parameters'
import wechatAuth from '../../wechatAuth'
import { Message, Loading } from 'element-ui'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import Tables from '../../components/tables/tables'
import echarts from 'echarts'
import { formatDate, formatTimeToStr } from '../../js/data'
import { getUserLocation } from '../../js/aMapApi.js'
import cityList from './cityList.vue'
import address_box from '../../components/address_box'
import userLocation from '../../mixin/userLocation.js'
export default {
  mixins: [userLocation],
  name: 'index',
  components: {
    Tables,
    cityList,
    address_box
  },
  data() {
    var vm = this
    return {
      two_list: [],
      tc_texts: '',
      search_show: false,
      search_value: this.$store.state.search_value,
      show_id_two: this.$store.state.show_id_two, //二级
      show_id: this.$store.state.show_id, //以及分类选择的id
      status_list: {
        // 0: "待付款",
        // 1: "下单失败",
        // 2: "下单部分失败",
        // 3: "已付款",
        // 4: "订单失效",
        // 5: "待评价"
        0: '待付款',
        1: '订单失效',
        2: '已取消',
        3: '订单失效',
        4: '已付款',
        5: '已完成',
        6: '已退款'
      },
      tpVisible: false,
      nav_show: this.$route.query.id ? this.$route.query.id : '1',
      user: '',
      z_page: 0,
      z_page1: 0,
      pageNumber: sessionStorage.getItem('pageNumber') ? Number(sessionStorage.getItem('pageNumber')) : 1,
      pageNumber1: sessionStorage.getItem('pageNumber1') ? Number(sessionStorage.getItem('pageNumber1')) : 1,
      loading: false,
      lb_list: '',
      order_list: '',
      no_show: false,
      loadings: false,
      lb_no_show: false,
      b_img: '',
      Categories: [],
      img_show: 2,
      priceLow: '',
      priceHigh: '',
      priceSort: '',
      NoticeText: '',
      AfterSale: '',
      tagLists: [],
      defaultAddress: null, //默认收货地址
      cityDataList: [],
      cityShow: false,
      addressVisible: false,
      outAdressCityId: '',
      lb_CityName: ''
    }
  },

  created() {
    // console.log('lb_cityIdlb_cityId', this.$storage.get('lb_cityId'))
  },
  async mounted() {
    var user = sessionStorage.getItem('user')
    var img_show = sessionStorage.getItem('img_show') ? sessionStorage.getItem('img_show') : this.img_show
    // let locationData = await getUserLocation().catch((res) => {}); //用户定位地址
    // console.log(locationData, "locationData");
    // console.log(this.defaultAddress, "this.defaultAddress");
    //   var headers = {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //       Authorization: this.user.token,
    //     };
    //  let {
    //       data: { default: cityList },
    //     } = await this.$server.queryLocation({}, headers);
    //  this.cityDataList = cityList.filter((val) => val.locationType === 2);
    // await this.adressCityChoose(this.defaultAddress, locationData); //处理用户地址和收货地址
    // await this.adressCityChoose(); //处理用户地址和收货地址
    if (user) {
      var users = JSON.parse(user)
      this.user = users
      await this.queryUserAddressall() //用户收货地址
      this.adressLoaction()
      // users.festival.remark = users&&users.festival&&users.festival.remark?users.festival.remark.replace('\n','\r'):''
    } else {
      this.$router.push({ path: '/login' })
    }
    if (img_show) {
      this.img_show = img_show == 2 ? true : false
    }
    sessionStorage.setItem('order_detail', '')
    this.querydocumentlists()
    this.getUser()
    console.log(this.user.festival.remark)
  },
  methods: {
    getRequest(Quert = true) {
      this.bindCategories()
      if (Quert) {
        this.bindqueryTags()
        this.bindorder()
      }
    },
    //关闭选择地址弹窗
    colseAdressClick() {
      this.addressVisible = false
      //   this.checkCity()
    },
    //检查是否有定位城市
    checkCity() {
      setTimeout(() => {
        if (!(this.$store.state.lb_cityId && this.$store.state.lb_cityId.id)) {
          this.failAdressUser()
        }
      }, 1000)
    },
    //处理定位城市
    async adressLoaction() {
      //是否有城市列表
      await this.getQueryLocation()

      this.cityDataList = this.$store.state.festival_cityList.filter((val) => val.locationType === 2)
      if (this.$store.state.lb_cityId && this.$store.state.lb_cityId.id) {
        this.getRequest()
        return
      }
      //定位中
      this.getSetTimeOutLocation(6000, (res) => {
        //定位成功超时处理
        let item = this.getMatchingCity(res.addressComponents)
        if (item) {
          //中台转换地址
          this.getAdressToCity(item.locationId, 'cityId').then((id) => {
            this.outAdressCityId = id
            this.lb_CityName = item.nameCn
          })
        }
      })
        .then((res) => {
          let locationData = ''
          if (res) {
            //定位成功不超时
            locationData = res.addressComponents
          }
          this.adressCityChoose(this.defaultAddress, locationData) //处理用户地址和收货地址
        })
        .catch(() => {
          console.log('定位市吧')
        })
    },
    //收货地址回调
    async bindselects(e) {
      let id = e.cityId
      let name = e.city
      if (this.municipalityDirectlyId.includes(e.provinceId)) {
        id = e.provinceId
        name = e.province
      }
      this.$store.commit('setFestivalCityId', { id, name })
      this.addressVisible = false
      this.bindgift()
    },
    //选择城市后回调
    async adressChangeCity(item) {
      let id = await this.getAdressToCity(item.locationId, 'cityId')
      this.$store.commit('setFestivalCityId', {
        id,
        name: item.nameCn
      })
      this.cityShow = false
      this.bindgift()
    },
    //收货地址与用户定位地址
    async adressCityChoose(defaultAddress, userAddress) {
      console.log('defaultAddress', defaultAddress)
      console.log('userAddress', userAddress)
      console.log('this.$store.state.lb_cityId', this.$store.state.lb_cityId)
      if (this.$store.state.lb_cityId && this.$store.state.lb_cityId.id) {
        this.getRequest()
        return Promise.resolve()
      }
      try {
        let curentCity = ''
        if (userAddress) {
          curentCity = this.getMatchingCity(userAddress)
        }
        if (curentCity) {
          let cityId = await this.getAdressToCity(curentCity.locationId, 'cityId')
          this.$store.commit('setFestivalCityId', {
            id: cityId,
            name: curentCity.nameCn
          })
          this.getRequest()
          return Promise.resolve()
        } else if (defaultAddress) {
          let id = defaultAddress.cityId
          let name = defaultAddress.city
          if (this.municipalityDirectlyId.includes(defaultAddress.provinceId)) {
            id = defaultAddress.provinceId
            name = defaultAddress.province
          }
          this.$store.commit('setFestivalCityId', {
            id,
            name
          })
          this.getRequest()
          return Promise.resolve()
        } else {
          this.getRequest(false)
          this.failAdressUser()
          //定位失败且没有收货地址
          return Promise.reject()
        }
      } catch (error) {
        this.getRequest(false)
        this.failAdressUser()
        return Promise.reject()
      }
    },
    //没有用户地址和定位失败是
    failAdressUser() {
      //定位超时处理
      if (this.outAdressCityId && !(this.$store.state.lb_cityId && this.$store.state.lb_cityId.id)) {
        this.$store.commit('setFestivalCityId', {
          id: this.outAdressCityId,
          name: this.lb_CityName
        })
        this.getRequest()
        return
      }
      this.$store.commit('setFestivalCityId', {})
      this.$confirm('为了您有更好的浏览体验，请先选择城市或创建收货地址。', '温馨提示?', {
        confirmButtonText: '创建收货地址',
        cancelButtonText: '选择城市',
        distinguishCancelAndClose: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          this.chooseAdress()
        })
        .catch((res) => {
          res == 'cancel' && this.selecCityPage()
        })
    },
    selecCityPage() {
      this.cityShow = true
    },
    //选择收货地址
    chooseAdress() {
      this.addressVisible = true
    },
    bindqueryTags() {
      // var headers = {
      //     'Content-Type':'application/x-www-form-urlencoded',
      //     'Authorization': this.user.token
      // }
      // this.$server.queryTags({},headers).then(res => {
      //   console.log('查询标签',res)
      //   if(res.code==0){
      //     this.tagLists = res.data.default
      //   }
      this.bindgift()
      // })
    },
    binddeleta(item, index) {
      let that = this
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var data = {
        orderId: item.id,
        orderTag: 21
      }
      this.$confirm('是否确认删除订单', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (confirm) {
          that.$server.deleteallorder(data, headers).then((res) => {
            if (res.code == 0) {
              var list = that.order_list
              list.splice(index, 1)
              if (list.length == 0) {
                that.no_show = true
              }
              that.order_list = list
              that.$message({
                message: '删除成功',
                type: 'success'
              })
            } else {
              that.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })
        }
      })
    },
    bindhide(item) {
      return this.$store.state.hidefestival.includes(this.user.festival.id) && this.$store.state.hidefestivalflId.includes(item.festivalCategoryId)
    },
    bindsearch_value(e) {
      this.$store.state.search_value = this.search_value
      console.log(e)
    },
    bindqx() {
      this.priceLow = ''
      this.priceHigh = ''
      this.pageNumber = 1
      this.bindgift()
    },
    bindqueding() {
      this.pageNumber = 1
      this.bindgift()
    },
    bindfocus() {},
    bindblur() {
      if (this.priceLow <= 0 && this.priceLow != '') {
        this.priceLow = 0
      }
      if (this.priceHigh <= 0 && this.priceHigh != '') {
        if (this.priceLow > 0) {
          this.priceHigh = this.priceLow
        } else {
          this.priceHigh = 0
        }
      }
    },
    bindzt(e) {
      console.log(e)
      this.pageNumber = 1
      this.bindgift()
    },
    querydocumentlists() {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var data = {
        clientPlatform: 1,
        type: '3,4'
      }
      this.$server.querydoclist(data, headers).then((res) => {
        console.log('公告', res)
        if (res.code == 0) {
          if (res.data && res.data.default) {
            var text = res.data.default.find((val) => val.type == 3)
            var text1 = res.data.default.find((val) => val.type == 4)
            this.NoticeText = text != undefined ? text.content : ''
            this.AfterSale = text1 != undefined ? text1.content : ''
          }
        }
      })
    },
    getUser() {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log('', res)
        if (res.code == 0) {
          var user = this.user
          this.$store.state.cardDate = res.data.default.cardDate
          this.$store.state.validTimes = res.data.default.validTimes
          this.$store.state.balance = res.data.default.balance
          sessionStorage.setItem('user', JSON.stringify(user))
        }
      })
    },
    bindqximg() {
      this.img_show = false
      sessionStorage.setItem('img_show', 1)
    },
    bindpay(item) {
      this.$router.push({
        path: '/order_pay',
        query: { order_id: item.uid }
      })
    },
    bindselete_two(e) {
      if (e == '') {
        this.show_id_two = ''
        this.pageNumber = 1
        this.bindgift()
        sessionStorage.setItem('pageNumber', this.pageNumber)
      } else {
        this.show_id_two = e
        this.pageNumber = 1
        this.bindgift()
        sessionStorage.setItem('pageNumber', this.pageNumber)
      }
    },
    bindselete_one(e, a) {
      // if(e==this.show_id){
      //   return
      // }
      if (a) {
        this.show_id_two = 0
        this.pageNumber = 1
      }
      this.show_id = e
      var list = this.Categories
      var lists = []
      list.forEach((item) => {
        if (item.parentCategoryId == e && item.parentCategoryId != 0) {
          lists.push(item)
        }
      })
      sessionStorage.setItem('pageNumber', this.pageNumber)
      this.two_list = lists
      if (lists.length > 0 && !this.show_id_two) {
        this.show_id_two = lists[0].id
      }
      this.bindgift()
    },
    bindtk(e) {
      console.log(e)
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization:
          'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyMSIsInVzZXJVaWQiOiI2OTU1OTEwMzk5MDk0OTQ3ODQiLCJ1c2VyTW9iaWxlIjoiNzAwMDAwMDA1MTQ6d2NYT090M0hEVURweXduZHdjS2p0QT09IiwidXNlckNsaWVudElwIjoiMTI3LjAuMC4xIiwiaWF0IjoxNTg1ODg1NTgyLCJzdWIiOiJsb3Jpc0BnbWFpbC5jb20iLCJpc3MiOiJ3d3cucGluby5jb20iLCJleHAiOjE1ODU4OTI3ODJ9.FwdToUx8AjLnDI5eei4nfQZBQ-vK8wm8a0qZ8ai7LAc'
      }
      var data = {
        orderUid: '2020040311323587543'
      }
      this.$server.testRefund(data, headers).then((res) => {
        console.log(res)
      })
    },
    bindpage(e) {
      console.log(e)
      sessionStorage.setItem('pageNumber', e)
      this.pageNumber = e
      this.bindgift()
    },
    bindpage1(e) {
      console.log(e)
      sessionStorage.setItem('pageNumber1', e)
      this.pageNumber1 = e
      this.bindorder()
    },
    bindCategories() {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var data = {
        festivalUid: this.user ? this.user.festival.uid : ''
      }
      this.$server.queryFestivalCategories(data, headers).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.Categories = res.data.default
          var list = res.data.default
          var lists = []
          list.forEach((item) => {
            if (item.parentCategoryId == 0) {
              lists.push(item)
            }
          })
          console.log(this.Categories)
          if (lists.length > 0) {
            if (this.$store.state.show_id) {
              this.bindselete_one(this.$store.state.show_id)
            } else {
              this.bindselete_one(lists[0].id)
            }
            if (this.$store.state.show_id_two) {
              this.show_id_two = this.$store.state.show_id_two
            }
          }
        }
      })
    },
    bindsearchs() {
      this.search_value = ''
      this.$store.state.search_value = ''
      this.pageNumber = 1
      sessionStorage.setItem('pageNumber', this.pageNumber)
      this.bindgift()
    },
    bindsearch() {
      this.pageNumber = 1
      sessionStorage.setItem('pageNumber', this.pageNumber)
      this.bindgift()
    },
    bindgift() {
      this.loading = true
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var priceSort = this.priceSort == '' || this.priceSort == 1 ? '' : this.priceSort == 2 ? 'asc' : 'desc'
      if (this.priceHigh < this.priceLow) {
        this.priceHigh = this.priceLow
      }
      var data = {
        pageNumber: this.pageNumber,
        festivalCategoryId: this.show_id_two == 0 ? (this.show_id == 0 ? '' : this.show_id) : this.show_id_two,
        pageSize: 10,
        festivalUid: this.user ? this.user.festival.uid : '',
        name: this.search_value,
        priceLow: this.priceLow ? this.priceLow * 100 : '', //价格下线
        priceHigh: this.priceHigh ? this.priceHigh * 100 : '', //价格上线
        priceSort: priceSort,
        cityId: this.$store.state.lb_cityId ? this.$store.state.lb_cityId.id || '' : ''
      }
      this.$server
        .queryFestivalPackages(data, headers)
        .then((res) => {
          this.loading = false
          if (data.name) {
            this.search_show = true
          } else {
            this.search_show = false
          }
          if (res.code == 0) {
            let lists = res.data.default.list
            // lists.forEach((item)=>{
            //   let tagNames = []
            //   if(item.tagIds&&this.tagLists){
            //     item.tagIds.forEach((tagitem)=>{
            //       let activetagitem = this.tagLists.find(val=>val.id==tagitem)
            //       if(activetagitem&&activetagitem!=undefined){
            //         tagNames.push(activetagitem.tagName)
            //       }
            //     })
            //   }
            //   item.tagNames = tagNames
            // })

            this.lb_list = lists
            this.z_page = res.data.default.totalCount
            if (res.data.default.totalCount == 0) {
              this.lb_no_show = true
            } else {
              this.lb_no_show = false
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      setTimeout(() => {
        this.loading = false
      }, 10000)
    },
    bindorder() {
      this.loadings = true
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var data = {
        pageNumber: this.pageNumber1,
        pageSize: 6,
        isFestivalPackage: true
      }
      this.$server
        .queryItemOrders(data, headers)
        .then((res) => {
          this.loadings = false
          if (res.code == 0) {
            var list = res.data.default.list
            list.forEach((item) => {
              var all_num = 0
              item.orderItems.forEach((item1) => {
                if (item1.skuName != '运费') {
                  all_num += item1.purchaseNumber
                }
              })
              item.all_num = all_num
            })
            this.order_list = list
            this.z_page1 = res.data.default.totalCount
            console.log(res.data.default.totalCount)
            if (res.data.default.totalCount == 0) {
              this.no_show = true
            } else {
              this.no_show = false
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      setTimeout(() => {
        this.loadings = false
      }, 10000)
    },
    bindnav(e) {
      this.nav_show = e
      this.$router.push({ path: '/', query: { id: e } })
      if (e == 2) {
        this.bindorder()
      }
    },
    binddetail(e) {
      console.log(e)
      // //				this.$router.push({path:'/detail',query:{one:this.one_show,two:this.two_show,three:this.three_show,id:e.id}})
      // const { href } = this.$router.resolve({
      //   path: "/detail",
      //   query: {
      //     id: e
      //   }
      // });
      // window.open(href, "_blank");
      var hidetype = this.bindhide(e)
      this.$router.push({
        path: '/detail',
        query: { id: e.uid, hidetype: hidetype }
      })
      this.$store.state.show_id_two = this.show_id_two
      this.$store.state.show_id = this.show_id
    },
    binddh(e) {
      this.$router.push({ path: '/address', query: { id: e } })
    },
    bindorderdetail(e, a) {
      this.$router.push({ path: '/order_detail', query: { id: e, name: a } })
    },
    queryUserAddressall() {
      return new Promise((resolve, reject) => {
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server
          .queryaddress({}, headers)
          .then((res) => {
            if (res.code === 0) {
              var list = res.data.default
              if (list) {
                var defaultAddress = list.find((val) => val.defaultAddress)
                if (defaultAddress != undefined) {
                  this.defaultAddress = defaultAddress
                } else {
                  this.defaultAddress = list[0]
                }
              }
            }
            resolve()
          })
          .catch((err) => {
            resolve()
          })
      })
    }
  },
  computed: {
    getCity() {
      if (this.$store.state.lb_cityId && this.$store.state.lb_cityId.name) {
        let names = this.$store.state.lb_cityId.name.indexOf('市') == -1 ? '市' : ''
        return this.$store.state.lb_cityId.name + names
      } else {
        return '请选择城市'
      }
    }
  },
  watch: {
    cityShow: {
      handler(newVal, oldVal) {
        if (newVal === false) {
          console.log('关闭了城市弹窗')
          this.checkCity()
        }
      },
      deep: true
    },
    addressVisible: {
      handler(newVal, oldVal) {
        if (newVal === false) {
          console.log('关闭了收货地址弹窗')
          this.checkCity()
        }
      },
      deep: true
    }
  }
}
</script>


<style lang="scss" scoped>
/deep/.el-dialog__wrapper {
  overflow: hidden !important;
}
.label {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.label span {
  border: 1px solid #f3a251;
  color: #f3a251;
  padding: 0 5px;
  font-size: 12px;
  // width:62px;
  text-align: center;
  // display: -webkit-box;
  // word-break: break-all;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
  // margin-top:5px;
}
.t_icon {
  text-align: center;
  position: absolute;
  width: 100%;
  top: -40px;
}
.tc_text {
  padding: 0 30px;
  max-height: 250px;
  min-height: 150px;
  overflow: auto;
  padding-bottom: 30px;
  font-size: 16px;
  margin-right: 15px;
  padding-right: 15px;
}
.tc_title {
  text-align: center;
  padding-top: 50px;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
}
.tc_center {
  width: 440px;
  // height:400px;
  background: white;
  border-radius: 8px;
}
.center_nav {
  height: 46px;
  width: 1260px;
  margin: auto;
  background: white;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 12px 0;
  .sx {
    border: 1px solid #ff5c4d;
    color: #ff5c4d;
    height: 26px;
    width: 84px;
    background: white;
    padding: 0 6px;
    display: flex;
    align-items: center;
    position: absolute;
    font-size: 12px;
    right: 0;
    img {
      margin-top: 2px;
      margin-left: 5px;
    }
    /*bottom:0;
				left:0;
				top:0;
				margin:auto;*/
  }
  .dianss {
    z-index: 99999;
    box-shadow: 0px 1px 3px #666666;
  }
  .dians {
    width: 330px;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 10px;
    // background:#F0F0F0;
    height: 32px;

    input {
      border: none;
      background: white;
      border: 1px solid #dddddd;
      outline: none;
      width: 70px;
      height: 24px;
      padding-left: 10px;
      font-size: 12px;
    }
    span {
      color: #666666;
      margin: 0 10px;
    }
  }
  .ppx {
    width: 122px;
    height: 100%;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 20px;
    cursor: pointer;
    img {
      height: 20px;
      margin-top: 3px;
    }
  }
}
.tc_box {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}
.tc_box p {
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
}
.tc_box .img_box {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  //  height:604px;width:440px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.tc_box .img1 {
  height: 60vh;
  // width:440px;
}
.tc_box .img2 {
  height: 40px;
  width: 40px;
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  margin: auto;
}
.search_box {
  width: 289px;
  border: 1px solid #f5f5f5;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.search_box img {
  height: 18px;
  width: 18px;
  margin-left: 10px;
}
.search_box input {
  border: none;
  padding: 0 10px;
  height: 18px;
  line-height: 18px;
  outline: none;
}
.search_box span {
  display: inline-block;
  height: 32px;
  width: 50px !important;
  text-align: center;
  line-height: 32px;
  background: #f0f0f0;
}
.ljfk_h {
  width: 90px;
  height: 32px;
  background: #f3a251;
  border-radius: 16px;
  line-height: 32px;
  text-align: center;
  color: white;
  margin-bottom: 6px;
  cursor: pointer;
}
.fl_box_ell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding: 0 4px;
}
.fl_box {
  padding: 20px;
  margin: 0 auto;
  padding-bottom: 0;
  margin-bottom: 20px;
  background: white;
  width: 1260px;
}
.one_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.two_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 24px;
}
.two_box span {
  display: inline-block;
  width: 120px;
  height: 32px;
  background: #f2f2f2;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  margin-right: 16px;
}
.two_active {
  border: 1px solid #f3a251;
  background: #fff8f1 !important;
  color: #f3a251;
}
.one_box span:nth-child(7n + 7) {
  margin-right: 0;
}
.one_box span {
  display: inline-block;
  height: 40px;
  margin-right: 16px;
  cursor: pointer;
  margin-bottom: 16px;
  width: 160px;
  text-align: center;
  line-height: 40px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.one_active {
  color: white;
  background: #f3a251;
  border: none;
}
.sell {
  background: #cccccc !important;
}
.nav span:hover {
  color: #f3a251;
}
.fy {
  text-align: center;
  padding-bottom: 20px;
}
.ydh {
  display: inline-block;
  opacity: 0.7;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  justify-content: space-around;
  right: 0;
  display: flex;
  align-items: center;
  margin: auto;
  background: #343333;
  text-align: center;
  // line-height: 60px;
  color: white;
}
.order {
  width: 1260px;
  min-height: 78vh;
  margin: 0 auto;
  .order_box:hover {
    border: 1px solid #f3a251;
  }
  .order_box {
    height: 152px;
    transition: all 0.5s;
    margin-bottom: 20px;
    width: 100%;
    border: 1px solid #ebebeb;
    .order_bottom {
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .order_bottom .order_b_left {
      display: flex;
      align-items: center;
      width: 400px;
    }
    .order_top {
      background: #f7f7f7;
      font-size: 14px;
      height: 40px;
      display: flex;
      align-items: center;
      color: #5b5d66;
    }
  }
}
.nav {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 200px;
  span {
    color: #909199;
    font-size: 16px;
    display: inline-block;
    height: 32px;
    cursor: pointer;
    width: 100px;
    line-height: 32px;
    text-align: center;
  }
  .nav_active {
    background: #f0f0f0;
    color: #0a1132 !important;
  }
}
.list {
  width: 1260px;
  min-height: 700px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 24px;
  .box:nth-child(5n + 5) {
    margin-right: 0;
  }
  .box:hover {
    border: 1px solid #f3a251;
  }
  .box {
    border: 1px solid white;
    height: 322px;
    transition: all 0.5s;
    width: 240px;
    cursor: pointer;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-right: 15px;
    padding: 16px;
    margin-bottom: 16px;
    img {
      height: 160px;
      width: 160px;
      background: #f4f4f4;
    }
    p {
      color: #0a1132;
      // margin-top:16px;
      text-align: center;
      // margin-bottom:24px;
    }
    .div {
      height: 30px;
      width: 120px;
      font-size: 12px;
      color: white;
      background: #f3a251;
      text-align: center;
      border-radius: 50px;
      line-height: 30px;
    }
  }
}
.sm_box {
  width: 950px;
  height: 160px;
  background: white;
  padding: 20px 30px;
  .sm_center {
    color: #5b5d66;
    display: flex;
    // align-items: center;
    font-size: 14px;
    // span:nth-child(1) {
    //   display: inline-block;
    //   height: 6px;
    //   width: 6px;
    //   border-radius: 50%;
    //   background: #5b5d66;
    //   margin-right: 5px;
    // }
  }
  .sm_top {
    .dh_jj {
      background: #fbbf45;
      border-radius: 50px;
      height: 32px;
      width: 98px;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
      display: inline-block;
      color: white;
    }
  }
}
.sy_big {
  background: #f7f7f7;
  position: relative;
}
.banner {
  max-height: 600px;
  width: 100%;
  img {
    max-height: 600px;
    width: 100%;
  }
}
.city_box {
  width: 1260px;
  margin: auto;
  div {
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 20px;
    display: inline-block;
    background: white;
    position: relative;
    &::before {
      content: ' ';
      display: inline-block;
      border: 4px solid transparent;
      border-top: 4px solid #333;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 4px;
    }
  }
}
</style>
